import { getEnvironmentConfig } from "@/config/environment";

interface FeedbackRequest {
  response_id: string;
  rating: string;
  comment?: string;
}

interface FeedbackResponse {
  success: boolean;
  message?: string;
}

export class FeedbackApiService {
  private readonly baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  async submitFeedback(responseId: string, rating: 'like' | 'dislike', comment?: string): Promise<FeedbackResponse> {
    const requestBody: FeedbackRequest = {
      response_id: responseId,
      rating: rating,
      ...(comment && { comment })
    };

    console.log('🎯 Submitting feedback:', requestBody);

    const response = await fetch(`${this.baseUrl}/api/v1/feedback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '1'
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Feedback submitted successfully:', data);
    return data;
  }
}

// Factory function to get the appropriate service based on environment
export const getFeedbackService = () => {
  const config = getEnvironmentConfig();
  return new FeedbackApiService(config.apiUrl);
};

// Export a singleton instance
export const feedbackService = getFeedbackService();
